export const RESOURCE_TYPE_OPTIONS = [
  { label: 'All resource types', value: '' },
  { label: 'AWS S3 Bucket', value: 'aws::s3::bucket' },
  { label: 'AWS EC2 Instance', value: 'aws::ec2::instance' },
  { label: 'AWS Lambda Function', value: 'aws::lambda::function' },
  { label: 'AWS IAM Role', value: 'aws::iam::role' },
  { label: 'AWS RDS Instance', value: 'aws::rds::instance' },
  { label: 'Code Package', value: 'code::package' },
];
